import { inputTypeValue } from '../const/inputTypeValue'

export const getTypeInput = (typeValue: String) => {
  switch (typeValue) {
    case inputTypeValue.TEXTO: {
      return 'text'
    }
    case inputTypeValue.CARACTER: {
      return 'text'
    }
    case inputTypeValue.NUMERO_TIPO_INT: {
      return 'number'
    }
    case inputTypeValue.NUMERO_TIPO_DOUBLE: {
      return 'number'
    }

    case inputTypeValue.NUMERO_TIPO_FLOAT: {
      return 'number'
    }

    case inputTypeValue.BOOLEAN_DATO_LOGICO: {
      return 'checkbox'
    }

    default: {
      return ''
    }
  }
}
